module.exports = __webpack_public_path__ + "static/media/EventLandingPage.7d7ae3a6.jpeg";